/// <reference path="" />


(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Application Information Data View Model
    // Holds additional application information information for an applicant
    /**************************************/
    function ApplicationInformationViewModel() {

        // Self-Identification
        var self = this;
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        /***  LIST DATA PROPERTIES ***/
        this.CommunicationTypes = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        /***  PROPERTIES ***/
        this.HeardAboutInstituteFrom = ko.validatedObservable();
        this.InstituteCoursesPreviouslyTaken = ko.validatedObservable();
        this.InterviewViaSkype = ko.validatedObservable();
        this.InterviewSkypeNameOrEmail = ko.validatedObservable();
        this.InterviewViaPhone = ko.validatedObservable();
        this.InterviewPhoneNumber = ko.validatedObservable();
        this.InterviewInPerson = ko.validatedObservable();
        this.PreferredCommunicationTypeID = ko.validatedObservable();
        this.InstituteRelationship = ko.validatedObservable();
        this.InstituteRelationshipName = ko.validatedObservable();
        this.InstituteRelationshipDescription = ko.validatedObservable();
        this.PersonalStatement = ko.validatedObservable();

        this.UpdateTemplateProperties = {
            HideHeardAboutInstituteFrom : ko.observable(false),
            HideInstituteRelationship : ko.observable(false),
            InterviewPreferencesTemplate : ko.observable(''),
            HideInterviewPreferences : ko.observable(false),
            HideInterviewViaPhone : ko.observable(false),
            HidePreferredCommunicationType : ko.observable(false),
            HidePersonalStatement : ko.observable(false)
        }

        sm.portal.vm.custom.setCustomLocalizeKey(self.UpdateTemplateProperties);

        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("ApplicationInformationContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.isPersonalStatementValid = ko.observable(true);
        /*** SECTION PROPERTIES ***/

        sm.portal.vm.custom.callCustomization('UpdateApplicationInfoProperties', self);
        /*** SUBSECTION PROPERTIES ***/

        /*** SUBSECTION PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(this.HeardAboutInstituteFrom())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InstituteRelationship())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InstituteRelationshipName())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InstituteRelationshipDescription())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InstituteCoursesPreviouslyTaken())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InterviewViaSkype())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InterviewSkypeNameOrEmail())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InterviewViaPhone())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InterviewPhoneNumber())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.InterviewInPerson())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.PreferredCommunicationTypeID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.PersonalStatement())) return true;

            var response = sm.portal.vm.custom.callCustomization('PopulateCustomAppInfoData', self);
            if (response != undefined) {
                return response;
            }

            return false;

        }, this);
        this.ShowInterviewSkypeNameOrEmail = ko.computed(function () {
            if (!this.InterviewViaSkype()) {
                this.InterviewSkypeNameOrEmail(null);
            };

            return this.InterviewViaSkype();
        }, this);
        this.ShowInterviewPhoneNumber = ko.computed(function () {
            if (!this.InterviewViaPhone()) {
                this.InterviewPhoneNumber(null);
            };

            return this.InterviewViaPhone();
        }, this);
        this.ShowInstituteRelationshipDetails = ko.computed(function () {
            if (!this.InstituteRelationship()) {
                this.InstituteRelationshipName(null);
                this.InstituteRelationshipDescription(null);
            };

            return this.InstituteRelationship();
        }, this);

        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container) {
            // update application section configurations
            if(container && container.Payload && container.Payload.Config){
                viewModel.SetSectionsConfigData("ApplicationInformation", container.Payload.Config);
                var customData = {
                    container : container, 
                    self: self
                };
                sm.portal.vm.custom.callCustomization('LoadAdditionalDataForAppInfo', customData);
            }

            if(container.Payload.ListData){
                this.CommunicationTypes = smapi.access.loadListItemModels(container.Payload.ListData.CommunicationTypes, this.CommunicationTypes);
            }
            if (container.Payload.ApplicationInformation != null) {
                this.HeardAboutInstituteFrom(container.Payload.ApplicationInformation.HeardAboutInstituteFrom);
                this.InstituteCoursesPreviouslyTaken(container.Payload.ApplicationInformation.InstituteCoursesPreviouslyTaken);
                this.InstituteRelationship(container.Payload.ApplicationInformation.InstituteRelationship);
                this.InstituteRelationshipName(container.Payload.ApplicationInformation.InstituteRelationshipName);
                this.InstituteRelationshipDescription(container.Payload.ApplicationInformation.InstituteRelationshipDescription);
                this.InterviewViaSkype(container.Payload.ApplicationInformation.InterviewViaSkype);
                this.InterviewSkypeNameOrEmail(container.Payload.ApplicationInformation.InterviewSkypeNameOrEmail);
                this.InterviewViaPhone(container.Payload.ApplicationInformation.InterviewViaPhone);
                this.InterviewPhoneNumber(container.Payload.ApplicationInformation.InterviewPhoneNumber);
                this.InterviewInPerson(container.Payload.ApplicationInformation.InterviewInPerson);
                this.PreferredCommunicationTypeID(container.Payload.ApplicationInformation.PreferredCommunicationTypeID);
                this.PersonalStatement(container.Payload.ApplicationInformation.PersonalStatement);
            }

            var customData = {
                container: container,
                self: self
            }
            sm.portal.vm.custom.callCustomization('PopulateHeardAboutInstituteFrom', customData);

            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[ApplicationInformationVM] Data Loaded'); }
        };
        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                    if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    self.LoadModel(viewModel.allCustomData().ApplicationInformation);
                    callback && callback(viewModel.allCustomData().ApplicationInformation);
                    return;
                }
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=applicationinformation&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            var stdApplicationInformation = new smapi.admissions.AdmissionsAttemptUKAdditionalInfoModel({
                HeardAboutInstituteFrom: self.HeardAboutInstituteFrom(),
                InstituteCoursesPreviouslyTaken: self.InstituteCoursesPreviouslyTaken(),
                InstituteRelationship: self.InstituteRelationship(),
                InstituteRelationshipName: self.InstituteRelationshipName(),
                InstituteRelationshipDescription: self.InstituteRelationshipDescription(),
                InterviewViaSkype: self.InterviewViaSkype(),
                InterviewSkypeNameOrEmail: self.InterviewSkypeNameOrEmail(),
                InterviewViaPhone: self.InterviewViaPhone(),
                InterviewPhoneNumber: self.InterviewPhoneNumber(),
                InterviewInPerson: self.InterviewInPerson(),
                PreferredCommunicationTypeID: self.PreferredCommunicationTypeID()
            });
            var customData = {
                stdApplicationInformation: stdApplicationInformation,
                self: self
            }
            sm.portal.vm.custom.callCustomization('ExtractApplicationInfoATO', customData);

            var stdPersonalStatement = new smapi.admissions.AdmissionsAttemptUKPersonalStatementModel({
                PersonalStatement: self.PersonalStatement
            });
            return {
                ApplicationInformation: stdApplicationInformation,
                PersonalStatement: stdPersonalStatement
            };

        };
        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/
        sm.portal.vm.custom.callCustomization('OverrideAppInfoValidation', self);

        this.HeardAboutInstituteFrom.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InstituteCoursesPreviouslyTaken.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.InstituteRelationshipName.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.InstituteRelationshipDescription.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InterviewSkypeNameOrEmail.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InterviewPhoneNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PreferredCommunicationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // this is to ensure maximum length is not greater than 4000 and every line break is counted as 2 characters 
        this.checkLengthPersonal = function () {
            var totalLength = 4000;
            if (!sm.portal.utility.isNullOrEmpty(self.PersonalStatement())) {
                var textLength = self.PersonalStatement().length;
                var lineBreakCount = self.PersonalStatement().match(/(\r\n|\n|\r)/g) ? self.PersonalStatement().match(/(\r\n|\n|\r)/g).length : 0;
                var len = textLength + lineBreakCount;
                if (len <= totalLength)
                    self.isPersonalStatementValid(true);
                else
                    self.isPersonalStatementValid(false);
            }
            else
                self.isPersonalStatementValid(true);
        }

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        this.Completed = ko.computed(function () {
            // No Required Fields
            var data ={
                AnythingPopulated : this.AnythingPopulated(),
                Touched : this.Touched()
            }
            var isCompletedCustom = this.IsVMValid() && sm.portal.vm.custom.callCustomization('CompletedCustom', data);
            if(!sm.portal.utility.isNullOrEmpty(isCompletedCustom)){
                return isCompletedCustom;
            }
            var isCompleted = this.IsVMValid() && (this.AnythingPopulated() || this.Touched());
            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        ApplicationInformationViewModel: ApplicationInformationViewModel
    });

})(jQuery);